module.exports = __webpack_public_path__ + "static/img/VE@3x.22781463.jpg";